// Loader.js
import React from "react";

function Loader() {
  return (
    <div className="button-loader">
      <div className="loader-spinner"></div>
    </div>
  );
}

export default Loader;